import { render, staticRenderFns } from "./OwnClassTeacherEditDialog.vue?vue&type=template&id=1896d44e"
import script from "./OwnClassTeacherEditDialog.vue?vue&type=script&lang=js"
export * from "./OwnClassTeacherEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports